
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(()=> ({
    btn: {
        color: "#999",
        fontSize: "18px",
        fontWeight: "400",
        cursor: "pointer"
    },
    select: {
        color: "#9373B1",
        borderBottom: "2px solid #9373B1",
        fontWeight: "700"
    },
    containerInput: {
        alignItems: "baseline",
        '& .MuiBox-root':{
            width: "100%"
        },
        '& .MuiFormControl-root':{
            '& .MuiFormLabel-root': {
                color: "#9373B1"
            },
            '& >div': {
                cursor: "pointer",
                display: "flex",
                '& section':{
                    display: "none",
                },
                '& :hover section': {
                    color: "#000",
                    display: "flex",
                    position: "absolute",
                    padding: "8px",
                    backgroundColor: "#eee",
                    zIndex: "2",
                    top: "0",
                    borderRadius: "10px",
                }
            },
            
            '& .MuiFormGroup-root': {
                display: "flex",
                flexDirection: "row",
                marginLeft: "15px",
                '& .MuiFormControlLabel-root': {
                    flexDirection: "row-reverse",
                    color: "#707070",
                    '& .MuiButtonBase-root': {
                        color: "#5567AE"
                    }
                }
            }
        }
    },
    containerActividadFiscal: { 
        '& .MuiInputBase-root': {
            marginTop:"0px",    
            borderTop: "1px solid rgba(0, 0, 0, 0.42)",
            borderLeft: "1px solid rgba(0, 0, 0, 0.42)",
            borderRight:"1px solid rgba(0, 0, 0, 0.42)",
            borderRadius:"10px",
            '&, &::before': { 
                borderRadius:"10px",
            } 
        },
        '& .MuiFormControl-root': {
            '& label':{
                position:"sticky",
                color: "#9373B1",
            },
            '& input': { 
               textAlign:"start",
                height: "90px"
            },

            '& input:focus': {
                 '&, &::after' :{
                     borderBottom:"1px solid #9373B1 !important", 
                     borderRight:"1px solid #9373B1 !important", 
                     borderTop:"1px solid #9373B1 !important", 
                     borderLeft: "1px solid #9373B1 !important",
                     borderRadius:"10px",
                     zIndex: "2"
                 },
            },
            '& legend': {
                display:"none"
            }
     }
    }
}))